import gql from 'graphql-tag';

export class ContentLinkMutations {
  static createMutation = gql`
    mutation CreateContentLinkBlock(
      $url: String!
      $title: String!
      $thumbUrl: String
      $thumbExtension: String
      $description: String!
      $buttonText: String!
    ) {
      createContentLinkBlock(
        url: $url
        title: $title
        thumbUrl: $thumbUrl
        thumbExtension: $thumbExtension
        description: $description
        buttonText: $buttonText
      ) {
        id
        url
        title
        thumbUrl
        thumbExtension
        buttonText
        description
      }
    }
  `;

  static updateBlockMutation = gql`
    mutation UpdateContentLinkBlock(
      $title: String!
      $description: String!
      $thumbUrl: String
      $thumbExtension: String
      $url: String!
      $userId: String
      $buttonText: String!
      $id: String!
    ) {
      updateContentLinkBlock(
        title: $title
        description: $description
        thumbUrl: $thumbUrl
        thumbExtension: $thumbExtension
        url: $url
        userId: $userId
        buttonText: $buttonText
        id: $id
      ) {
        id
        url
        title
        thumbUrl
        thumbExtension
        buttonText
        description
      }
    }
  `;

  static copyBlockMutation = gql`
    mutation CopyContentLinkBlock($id: String!) {
      copyContentLinkBlock(id: $id) {
        id
        entityId
        userId
        url
        title
        description
        thumbExtension
        buttonText
        thumbUrl
      }
    }
  `;
}
